module.exports = __webpack_public_path__ + "28ade970cffe0c17bb2744ceff65e043.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/svg/twitter-square.svg
// module id = 1103
// module chunks = 0